// theirs
import styled from 'styled-components'
import { getOurStoryLinks } from '../../content'
import { breakpoints, color, typography } from '../../styles'
// ours

interface FramingProps {
    className?: string
    testId?: string
}

const StyledNavAside = styled.div`
    position: absolute;
    top: 7rem;
    left: 3rem;
    padding: 0;
    margin: 0;
    z-index: 5;

    @media (min-width: ${breakpoints.xl}) {
        position: fixed;
    }

    @media (min-width: ${breakpoints.xxl}) {
        position: fixed;
        top: 12rem;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            margin: 1.5rem 0;

            @media (min-width: ${breakpoints.xxl}) {
                margin: 2rem 0;
            }
        }
    }

    a {
        font-family: ${typography.type.secondary};
        font-weight: ${typography.weight.bold};
        font-style: ${typography.style.normal};
        font-size: ${typography.size.m1};
        color: ${color.mediumdark};
        text-transform: uppercase;
        text-decoration: none;
        text-align: center;
        margin: 0;
        padding: 0;

        letter-spacing: normal;
        line-height: normal;
    }
`

const NavAside = ({ className, testId }: FramingProps) => {
    const ourStoryLinks = getOurStoryLinks()

    return (
        <StyledNavAside className={className} data-testid={testId}>
            <ul>
                {ourStoryLinks.map((chapter, index) => (
                    <li key={index}>
                        <a href={chapter.chapterUrl}>{chapter.chapterName}</a>
                    </li>
                ))}
            </ul>
        </StyledNavAside>
    )
}

export default NavAside
